import React from 'react';
import classNames from 'classnames/bind';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const PopupConnectionMainWrapper = ({ children }) => (
  <div className={cx('popup-connect-main')}>
    {children}
  </div>
);
